import * as base64js from "base64-js";
import * as jwtDecode from "jwt-decode";
import * as pako from "pako";
import config from "../../../config";

export type Permission = string;

export interface IAcl {
  systemLevel: Permission[];
  customerLevel: { [key: string]: string };
  siteLevel: { [key: string]: string };
}

interface IAccessTokenContents {
  deflated: boolean; // if payload is zipped
  exp: number; // expiration ts secs
  iat: number; // issued at ts secs
  iss: string; // issued by (ex. login-alphadev.traceair.net)
  payload: string; // zipped base64
  sub: string; // user email
}

interface ICompany {
  name?: string;
  type?: string;
}

export interface IUserProps {
  email: string;
  name?: string;
  lastname?: string;
  phone?: string;
  title?: string;
  company?: ICompany;
  department?: string;
  titleDescription?: string;
  lang: string;
  createdAt: string;
  updatedAt?: string;
}

export interface IAccessTokenPayload {
  ACL: IAcl;
  user: IUserProps;
}

// TODO: use access-token-js-lib
export function getPayloadFromToken(accessToken: string): IAccessTokenPayload {
  const tokenObject: IAccessTokenContents = jwtDecode(accessToken);
  const deflatedPayload: Uint8Array = base64js.toByteArray(tokenObject.payload);
  const decodedPayload = JSON.parse(
    pako.inflate(deflatedPayload, { to: "string" }),
  );
  return decodedPayload || {};
}

export function isAccessTokenExpired(
  accessToken: string,
  currentTimestamp: number,
): boolean {
  const { iat, exp }: IAccessTokenContents = jwtDecode(accessToken);
  const iatMs = iat * 1000;
  const expMs = exp * 1000;
  const tokenTtlMs = expMs - iatMs;
  const updateThreshold = iatMs + tokenTtlMs * config.tokenUpdateOvertakeFactor;
  return updateThreshold - currentTimestamp < 0;
}

export function getClientTimeOffset(accessToken: string): number {
  const { iat }: IAccessTokenContents = jwtDecode(accessToken);
  return Date.now() - iat * 1000;
}

export interface ITokenRequestData {
  customer: string;
  site: string;
}

export function canUseAsana(acl?: IAcl): boolean {
  return Boolean(acl?.systemLevel.includes("ASANA_ACCESS"));
}

export function canViewExistingControls(acl?: IAcl): boolean {
  return Boolean(
    acl?.systemLevel.includes("BACKOFFICE_GCP_EXISTING_CONTROLS_VIEW"),
  );
}
